module.exports = __webpack_public_path__ + "f55964e388846e9549358026b1f812c5.svg";